import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../nodeInstance";
import { CgSpinner } from "react-icons/cg";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";
import { getVrrData } from "../../../../store/Api";

export default function Visareturnfinancepopup({
  showPromptElement,
  setPopUp,
  poropData,
}) {
  console.log("propData.........",poropData)
  const token = localStorage.getItem("nodeToken");
  const dispatch = useDispatch();
  const [file, setFile] = useState();
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(null);
  const [amount, setAmount] = useState();
  const handleAmountChange = (event) => {
    setAmount(event.target.value);
  };
  const submitHandler = async (e, fileData, poropData) => {
    console.log("fileData......", fileData, file);
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("Date", date);
      formData.append("amount", amount);
      formData.append("vrr_reference_number",poropData.vrr_reference_number)
      console.log("ycgyuduyguggu.......", formData);
      if (fileData) {
        // formData.append("file", file);
        const response = await nodeinstance.put(
          `/dashboard/vrr-visa/updateVRRByFinance/${poropData.id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.status === 200) {
          setPopUp(false);
          dispatch(
            setAppError({
              msg: "Successfully uploaded.",
              color: "success",
            })
          );
          dispatch(getVrrData(token));
        }
        console.log("success to be seen here......", response);
      }
    } catch (err) {
      console.log("error", err);
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          showPromptElement ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <form
            onSubmit={(e) => submitHandler(e, file, poropData)}
            className="w-full"
          >
            <div className="w-full flex flex-col gap-3 my-3 p-5">
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  VRR REFERENCE NUMBER
                </label>
                <input
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  //   onChange={handleAmountChange}
                  value={poropData.vrr_reference_number}
                  disabled
                />
              </div>
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  PAYMENT DONE DATE
                </label>
                <input
                  type="Date"
                  value={date}
                  max={new Date().toISOString().split('T')[0]} 
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  onChange={(e) => {
                    setDate(e.target.value);
                  }}
                />
              </div>
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  AMOUNT
                </label>
                <input
                  type="number"
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  onChange={handleAmountChange}
                />
              </div>
              <div className="form-control w-full ">
                <label className="label">
                  <span className="label-text">Upload File</span>
                </label>
                <input
                  type="file"
                  className="file-input file-input-bordered w-full "
                  onChange={(e) => setFile(e.target.files[0])}
                  required
                  accept="image/*, application/doc, application/docx, application/pdf, application/xls, application/xlsx"
                />
              </div>
              <div
                className="flex gap-3 w-full justify-center"
                style={{ m: 2 }}
              >
                <button
                  type="submit"
                  className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                >
                  {" "}
                  <p>Submit</p>
                  {loading ? <CgSpinner className="animate-spin" /> : ""}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
